module.exports = __webpack_public_path__ + "static/media/learn.f85c515b.jpg";